
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ThankYou() {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-white rounded-lg shadow-xl p-8">
          {/* Success Icon */}
          <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
            <i className="ri-check-line text-3xl text-green-600"></i>
          </div>
          
          {/* Thank You Message */}
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Thanks for reaching out
          </h1>
          
          <p className="text-lg text-gray-600 mb-6">
            We received your message and will get back to you shortly.
          </p>
          
          <p className="text-sm text-gray-500 mb-8">
            If it's urgent, email mauricio@cadertalent.com
          </p>
          
          {/* Action Buttons */}
          <div className="space-y-3">
            <Link
              to="/"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer inline-block"
            >
              Return to Home
            </Link>
            
            <button
              onClick={() => window.history.back()}
              className="w-full border border-gray-300 hover:border-gray-400 text-gray-700 font-semibold py-3 px-6 rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
